module.exports = __webpack_public_path__ + "static/media/logo.c54f6c67.png";